import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sc-video-purchase-order-type-icon-component',
  templateUrl: './video-purchase-order-type-icon.component.html',
  styleUrls: ['./video-purchase-order-type-icon.component.scss']
})
export class VideoPurchaseOrderTypeIconComponent implements OnInit {
  @Input() type: string;

  constructor() {}

  public ngOnInit() {}
}
